import SchedulePage from './SchedulesPage';

export default SchedulePage;
